/* GENTCREATE — the back gesture closes what is open, it does not leave the page.
 *
 * On a phone almost nobody hunts for the X. They swipe back, or press the
 * system back button, and expect the thing on top to go away. Without this that
 * gesture leaves the product page entirely — the shopper is gone, and the only
 * way back is to find the product again. The same is true of the browser's back
 * button on a desktop.
 *
 * HOW IT WORKS. Opening an overlay pushes one history entry at the SAME url, so
 * nothing about the address changes and nothing is shared or bookmarked
 * differently. Back then lands on that entry instead of leaving, popstate fires,
 * and the topmost overlay is closed. Closing by any other means — the X, Escape,
 * the backdrop — removes the entry again with history.go, so the history stack
 * is left exactly as it was found.
 *
 * The registry is a stack because overlays nest: a story viewer opened from a
 * page that already has a drawer open should take two presses, in the right
 * order, and each press should close exactly one thing.
 *
 * USAGE, from any overlay:
 *     GCOverlayBack.opened('name', closeFunction)   // right after it opens
 *     GCOverlayBack.closed('name')                  // right after it closes
 *
 * closed() is deliberately safe to call from inside the close function itself:
 * when the close was triggered BY the back gesture the entry has already been
 * taken off the stack, so the call finds nothing and does nothing rather than
 * winding history a second time. */
(function () {
  'use strict';

  var stack = [];
  /* popstate events that this script caused itself, and must not act on */
  var selfInflicted = 0;

  function indexOf(name) {
    for (var i = stack.length - 1; i >= 0; i--) if (stack[i].name === name) return i;
    return -1;
  }

  function opened(name, close) {
    if (!name || typeof close !== 'function') return;
    if (indexOf(name) !== -1) return;           /* already tracked */
    stack.push({ name: name, close: close });
    try { history.pushState({ gcOverlay: name, depth: stack.length }, ''); } catch (e) {}
  }

  function closed(name) {
    var i = indexOf(name);
    if (i === -1) return;                        /* the back gesture already took it */
    var removed = stack.length - i;
    stack.splice(i, removed);
    selfInflicted += removed;
    try { history.go(-removed); } catch (e) { selfInflicted -= removed; }
  }

  window.addEventListener('popstate', function () {
    if (selfInflicted > 0) { selfInflicted--; return; }
    if (!stack.length) return;
    var top = stack.pop();
    try { top.close(); } catch (e) {}
  });

  /* a real navigation makes the stack meaningless */
  window.addEventListener('pagehide', function () { stack.length = 0; selfInflicted = 0; });

  window.GCOverlayBack = { opened: opened, closed: closed, depth: function () { return stack.length; } };
})();
